(ns accounts.views
  (:require
    [reagent.format :as fmt]
    [reagent.core :as r]
    [very.re-frame.core :as rf :refer [<sub >evt]]
    [oops.core :refer [oget]]
    [css.core
     :as css
     :refer [get-theme defstyled]]
    [css.vars :as vars]
    [css.form :as form]
    [css.typography :as typo]
    [css.icons :as icon]
    [cljss.core :as cljss]
    [accounts.tables :as tables]
    [graphs.core :refer [pie-chart]]
    [accounts.common :refer [colored-gain-or-loss-s medium-down-s]])

  (:require-macros
   [logging.core :refer [log]]))

(defstyled account-net-s :div
  {:display "flex"
   :align-items "center"
   ::cljss/media {[[:max-width "768px"]]
                  {:flex-direction "column"
                   :align-items "flex-start"}}})

(defn account-net [perf]
  [account-net-s
   [typo/h2 {:padding "0 .5rem 0 0"} "Account Totals:"]
   [typo/h2 {:font-weight "700"
             :color (get-theme :primary)
             :line-height "normal"} (fmt/currency-format (:total-value perf))]])

(defstyled assets-and-liabilities-s :div
  {:color "rgb(102,102,102)"
   :display "flex"
   :font-weight "700"
   :align-items "center"
   ::cljss/media {[[:max-width "980px"]]
                  {:margin-top "1rem"}
                  [[:max-width "768px"]]
                  {:margin-top "1.5rem"}}})

(defstyled asset-or-liability-label-s :h4
  {:font-weight "300"
   :font-size "1.33rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:font-size "14px"
                   :margin-bottom ".5rem"}}})

(defstyled asset-or-liability-s :h4
  {:padding "0 0 0 .5rem"
   :font-weight "700"
   :font-size "1.33rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:font-size "14px"}}})

(defstyled row-s :div
  {:display "flex"
   :align-items "center"
   :&:last-child {:margin-left "2rem"}
   ::cljss/media {[[:max-width "768px"]]
                  {:flex-direction "column"
                   :align-items "flex-start"}}})

(defn asset-or-liability [x]
  [asset-or-liability-s
   [colored-gain-or-loss-s {:value x} (fmt/currency-format x)]])

(defn assets-and-liabilities [perf]
  [assets-and-liabilities-s
   [row-s
    [asset-or-liability-label-s "Assets:"]
    [asset-or-liability (:assets perf)]]
   [row-s
    [asset-or-liability-label-s "Liabilities:"]
    [asset-or-liability (:liabilities perf)]]])

(defstyled button-text-s :div
  {:margin-right "1rem"
   :&:last-child {:margin-right "0"}})

(defn account-management []
  [form/button-row-s {:justify "start" :margin "0"}
   [form/button {:on-click #(>evt [:add-account])} "Add Account"]
   [form/button {:on-click #(>evt [:manage-accounts])
                 :grid-row "2"} "Manage Accounts"]])

(defn long-str [& strings]
  (clojure.string/join "" strings))

(defstyled strategy-allocation-s :div
  {:align-items "center"
   :display "flex"
   :flex-direction "column"
   :width "100%"
   ::cljss/media {[[:max-width "768px"]]
                  {:align-items "center"}}})

(defstyled allocation-link :a
  {:cursor "pointer"
   :font-size "0.93rem"
   :margin "0 0 2rem"
   :text-decoration "underline"
   ::cljss/media {[[:max-width "768px"]]
                  {:align-self "flex-start"
                   :font-size "1.25rem"}}})

(defstyled disclaimer-container-s :div
  {:display "flex"
   :flex-direction "column"
   :max-width "20rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:max-width "100%"}}})

(defstyled disclaimer-s :p
  {:color vars/gray
   :font-size "0.8rem"
   :line-height "17px"
   :margin-bottom "1rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:font-size "1.08rem"
                   :line-height "2rem"}}})

(defstyled header-align-s :div
  {:border-bottom (str "2px solid " (get-theme :primary))
   :display "flex"
   :width "100%"})

(defn allocation-evt [active-index]
  (fn  [d i]
    (let [volatile (js-obj "id" (oget d "id")
                           "color" (oget d "fill")
                           "name" (oget d "name")
                           "percent" (oget d "value"))
          edn (js->clj volatile :keywordize-keys true)]
      (reset! active-index i)
      (>evt [:account-focused edn]))))

(defn strategy-allocation [alloc]
  [strategy-allocation-s
   [header-align-s
    [typo/h3 {:line-height "46px"} "Investment Strategy Allocation"]]
   [pie-chart {:data alloc :gen-on-mouse-enter allocation-evt}]
   [allocation-link
    {:on-click #(rf/>evt [:sso-login :orion])}
    "For holding detail sign into Orion"]
   [disclaimer-container-s
    [disclaimer-s (long-str "The report includes securities held in your Custodian account(s) or "
                            "that Custodian does not hold on your behalf and which are not included "
                            "on Custodian's books and records.")]
    [disclaimer-s (long-str "This is not an official Pershing LLC, Fidelity, TD Ameritrade, or any"
                            "other directly held account (\"Custodian\") statement and does not replace "
                            "the statements you should receive directly from your Custodian, the "
                            "investment sponsor, or any other outside custodian.")]]])

(defstyled net-worth-and-assets-s :section
  {:align-items "center"
   :box-shadow "rgb(223, 223, 223) 0px 7px 12px -7px, rgb(223, 223, 223) 0px -7px 12px -7px;"
   :display "flex"
   :justify-content "space-between"
   :margin-bottom "4.5rem"
   :padding "1.4rem 0"
   ::cljss/media {[[:max-width "980px"]]
                  {:flex-direction "column"
                   :align-items "flex-start"}
                  [[:max-width "768px"]]
                  {:box-shadow "none"
                   :border-top (str "1px solid " vars/border-light)
                   :border-bottom (str "1px solid " vars/border-light)
                   :margin-bottom "3.5rem"}}})

(defstyled accounts-container-s :section
  {:display "grid"
   :grid-template-columns "[accounts-start] 2fr [accounts-end allocation-start] 1fr [allocation-end]"
   :grid-template-rows "[internal-start] min-content [internal-end external-start] min-content [external-end management-start] min-content [management-end]"
   :grid-gap "2.6rem 2.6rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "auto"
                   :grid-template-rows "[internal-start] min-content [internal-end allocation-start] min-content [allocation-end external-start] min-content [external-end management-start] min-content [management-end]"
                   :grid-gap "5rem 0"}}})

(defstyled internal-s :div
  {:display "grid"
   :grid-column "accounts"
   :grid-row "internal"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-column "auto"}}})

(defstyled external-s :div
  {:display "grid"
   :grid-column "accounts"
   :grid-row "external"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-column "auto"}}})

(defstyled management-s :div
  {:display "grid"
   :grid-column "accounts"
   :grid-row "management"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-column "auto"}}})

(defstyled allocation-s :div
  {:display "grid"
   :grid-column "allocation-start / allocation-end"
   :grid-row "internal-start / management-end"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-row "allocation"
                   :grid-column "auto"}}})

(defn show-graph []
  (let [show-graph? (r/atom true)]
    (fn [accounts]
      [allocation-s
       (if @show-graph?
         [:div [strategy-allocation accounts]])
       [medium-down-s
        [form/button {:on-click #(swap! show-graph? not)}
         [button-text-s (if @show-graph? "Hide Investment Strategy Allocation" "See Investment Strategy Allocation")]
         [icon/chart-white]]]])))

(defstyled accounts-grid-s :div
  {:grid-column "content"})

(defstyled accounts-s :div
  {:grid-column "content"})

(defn accounts []
  (let [external (<sub [:external-accounts])
        internal (<sub [:internal-accounts])
        total (<sub [:total-performance])]
    [accounts-grid-s {:data-test "my-accounts-page"}
     [accounts-s
      [typo/h1 {:margin "4.5rem 0 2.5rem"} "My accounts"]
      [net-worth-and-assets-s
       [account-net total]
       [assets-and-liabilities total]]
      [accounts-container-s
       [internal-s [tables/internal-accounts]]
       [external-s [tables/external-accounts external]]
       [management-s [account-management]]
       [show-graph (:accounts internal)]]]]))

